import { Fragment, useState } from 'react';
import { Modal as AntModal, Button as AntButton, Checkbox, Radio } from 'antd';
import { Field, Form, Formik } from 'formik';
import { object } from 'yup';
import { SingleSelect, Text } from '.';
import { Logo } from '@insight-health-ai/roseate/components';
import { classNames } from 'src/utilities';
import { DatePicker } from './Datepicker';
import { Input } from 'antd';
const { TextArea } = Input;
import ReactMarkdown from 'react-markdown';
import { PatternFormat } from 'react-number-format';
import { SliderComponent } from './Slider';

const vSchema = object({});

export const Modal = ({
  open,
  fields,
  validationSchema = vSchema,
  initialValues = {},
  submitButtonText = 'Ok',
  cancelButtonText = 'cancel',
  className,
  formClassName = '',
  onSubmitLoading,
  handleCancel = () => null,
  handleSubmit,
  heading,
  customBody,
  additionalBody,
  titleBody,
  centered = true,
  disableSubmit,
  hipaaTextContent,
  closable,
  validationText,
  hyperLink,
  onXIconClose = () => null,
  bangform,
  promisform,
}) => {
  const [textAllow, setTextAllow] = useState(false);

  return (
    <AntModal
      open={open}
      closable={closable}
      onCancel={() => {
        handleCancel();
        onXIconClose();
      }}
      className={classNames(`custom-modal`, className ? className : '')}
      centered={centered}
      footer={null}
    >
      <div className="modal__header flex flex-col items-center pb-[20px]">
        <Logo className="h-8" />
        {heading ? <span className="modal__header mt-3">{heading}</span> : ''}
      </div>
      <div className="modal____body">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <Form className="modal__form">
              {titleBody ? titleBody : ''}
              {customBody ? (
                customBody
              ) : (
                <div className={formClassName}>
                  {fields.map(
                    (
                      {
                        type,
                        name,
                        title,
                        helperTitle,
                        onChange,
                        dropdownArrow,
                        disableDate,
                        disableTime,
                        placeholder,
                        disabled,
                        values: value,
                        options,
                        onKeyPress,
                        tags,
                        leftLegend,
                        rightLegend,
                        className = '',
                        ...props
                      },
                      index
                    ) => (
                      <Fragment key={name}>
                        {type === 'slider' ? (
                          <SliderComponent
                            name={name}
                            title={title}
                            leftLegend={leftLegend}
                            rightLegend={rightLegend}
                          />
                        ) : type === 'datepicker' ? (
                          <DatePicker name={name} />
                        ) : type === 'checkbox' ? (
                          <div
                            className={`${className} modal__form-el`}
                            key={name}
                          >
                            <Text
                              type="label"
                              className="modal__form-el-label mb-2"
                            >
                              <Checkbox
                                className="mr-3"
                                key={name}
                                type={type}
                                disabled={disabled}
                                name={name}
                                onChange={(e) => {
                                  e.target.checked
                                    ? setFieldValue(name, true)
                                    : setFieldValue(name, false);
                                }}
                                checked={values[name]}
                              />
                              {title}
                            </Text>
                            {touched[name] && errors[name] && (
                              <Text type={'error'} className={'error mt-2'}>
                                {errors[name]}
                              </Text>
                            )}
                          </div>
                        ) : type === 'header' ? (
                          <div className="col-span-2 text-xl font-bold mb-2">
                            {name}
                          </div>
                        ) : type === 'label' ? (
                          <div className="col-span-2 text-xl mb-3">{name}</div>
                        ) : type === 'radio' ? (
                          <div className=" col-span-2 PFDI_modal">
                            <p
                              className={`col-span-2 font-bold mb-2 ${bangform || promisform ? 'text-medium' : 'text-xl'}`}
                            >
                              {title}
                            </p>
                            <Radio.Group
                              name={name}
                              onChange={(e) =>
                                setFieldValue(name, e.target.value)
                              }
                              className="custom-radio"
                            >
                              {options?.map((option, index) => (
                                <Radio key={index} value={option}>
                                  {option}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </div>
                        ) : type === 'textArea' ? (
                          <div>
                            <label className="modal__form-el-label">
                              {title}
                            </label>
                            <Field
                              className="modal__form-el-field"
                              as="textarea"
                              key={name}
                              type={type}
                              name={name}
                              render={({ field }) => (
                                <TextArea
                                  className="modal__form-el-textarea"
                                  {...field}
                                  placeholder={placeholder}
                                  disabled={disabled}
                                  value={values[name] || ''}
                                  onChange={(e) => {
                                    setFieldValue(name, e.target.value);
                                  }}
                                />
                              )}
                            />
                          </div>
                        ) : type === 'numbertext' ? (
                          <div>
                            <label className="modal__form-el-label">
                              {title}
                            </label>
                            <PatternFormat
                              className="modal__form-el-field mt-2"
                              key={name}
                              type={type}
                              name={name}
                              disabled={disabled}
                              placeholder={placeholder}
                              {...props}
                              format="##-##-####"
                              allowEmptyFormatting={false}
                              aria-autocomplete="off"
                              autoComplete="off"
                              value={values[name] || ''}
                              onValueChange={(values) => {
                                setFieldValue(name, values.value);
                              }}
                            />
                            {touched[name] && errors[name] && (
                              <Text type={'error'} className={'error mt-1'}>
                                {errors[name]}
                              </Text>
                            )}
                          </div>
                        ) : type === 'html' ? (
                          <>
                            <div
                              className="col-span-2"
                              style={{
                                padding: '75% 0 0 0',
                                position: 'relative',
                              }}
                            >
                              <iframe
                                src={title}
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: '100%',
                                  height: '100%',
                                }}
                                title="Hello World!"
                              ></iframe>
                            </div>
                          </>
                        ) : type === 'tagify' ? (
                          <div key={name}>
                            <Text
                              type="label"
                              className="modal__form-el-textarea-heading"
                            >
                              {title}
                            </Text>
                            <div
                              className={`${className} input-container`}
                              key={name}
                            >
                              <div
                                className={`${className} modal__form-el`}
                                key={name}
                              >
                                {touched[name] && errors[name] && (
                                  <Text type={'error'} className={'error'}>
                                    {errors[name]}
                                  </Text>
                                )}
                                <div>
                                  {Array.isArray(tags) && tags.length > 0
                                    ? tags.map((tag, index) =>
                                        tag.trim() ? (
                                          <div
                                            key={index}
                                            className="allergy-item"
                                          >
                                            {tag}
                                            <button
                                              type="button"
                                              name={name}
                                              onClick={(e) =>
                                                props.handleRemoveTag(e, index)
                                              }
                                              className="modal__form-el-remove-button"
                                            >
                                              ✖
                                            </button>
                                          </div>
                                        ) : null
                                      )
                                    : null}
                                  {props?.isInputVisible?.[name] && (
                                    <div>
                                      <input
                                        type="text"
                                        className="medi"
                                        name={name}
                                        placeholder={`Enter your ${title} :`}
                                        value={props.newTag[name]}
                                        onChange={(e) =>
                                          props.setNewTag({
                                            ...props.newTag,
                                            [e.target.name]: e.target.value,
                                          })
                                        }
                                        // ref={tagifyRef}
                                        onKeyDown={(e) => {
                                          if (e.key === 'Enter') {
                                            props.handleEnterKeyPress(e);
                                          }
                                        }}
                                      />
                                      <button
                                        type="button"
                                        name={name}
                                        onClick={props.handleAddTag}
                                        className="modal__form-el-plus-button"
                                      >
                                        <span className="text-xl">&#43;</span>{' '}
                                        Add
                                      </button>
                                    </div>
                                  )}
                                  {!props?.isInputVisible?.[name] && (
                                    <button
                                      type="button"
                                      name={name}
                                      onClick={(e) =>
                                        props.setIsInputVisible({
                                          ...props.isInputVisible,
                                          [e.target.name]: true,
                                        })
                                      }
                                      className="modal__form-el-plus-button"
                                    >
                                      <span className="text-xl">&#43;</span> Add
                                    </button>
                                  )}
                                  {/* <Tagify value={medicationArray} /> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : type === 'select' ? (
                          <div>
                            <label className="modal__form-el-label">
                              {title}
                            </label>
                            <SingleSelect
                              name={name}
                              options={options}
                              placeholder={placeholder}
                              disabled={disabled}
                              className={`${className} ${touched[name] && errors[name] ? 'error' : ''}`}
                              popupClassName={`${'font-sans'}`}
                              onChange={
                                onChange
                                  ? (value, option) => {
                                      onChange(value, option, setFieldValue);
                                    }
                                  : () => null
                              }
                              value={values[name]}
                              dropdownArrow={dropdownArrow}
                              error={touched[name] && errors[name]}
                            />
                          </div>
                        ) : type === 'div' ? (
                          <div
                            className={`${className} modal__form-el-textarea`}
                            key={name}
                          >
                            <div
                              className="markdown-container"
                              style={{ whiteSpace: 'pre-line' }}
                            >
                              <ReactMarkdown>{hipaaTextContent}</ReactMarkdown>
                            </div>

                            {helperTitle}
                          </div>
                        ) : type === 'checkbox_with_text' ? (
                          <div
                            className={`${className} modal__form-el`}
                            key={name}
                          >
                            <Text
                              type="label"
                              className="modal__form-el-label mb-2"
                            >
                              <Checkbox
                                className="mr-3"
                                onChange={(e) => {
                                  setTextAllow(e.target.checked);
                                }}
                                checked={textAllow}
                              />
                              {title}
                            </Text>
                            {touched[name] && errors[name] && (
                              <Text type={'error'} className={'error mt-2'}>
                                {errors[name]}
                              </Text>
                            )}
                            {textAllow ? (
                              <Field
                                className="input"
                                key={name}
                                type={type}
                                name={name}
                                disabled={disabled}
                                placeholder={placeholder}
                                {...props}
                              />
                            ) : (
                              ''
                            )}
                          </div>
                        ) : (
                          <div
                            className={`${className} modal__form-el`}
                            key={name}
                          >
                            <Text
                              type="p"
                              className="modal__form-el-label mb-2"
                            >
                              {title}
                            </Text>
                            <Field
                              className="modal__form-el-field"
                              key={name}
                              type={type}
                              name={name}
                              disabled={disabled}
                              placeholder={placeholder}
                              {...props}
                            />
                            {helperTitle ? (
                              <Text
                                type="p"
                                className="modal__form-el-label mb-2"
                              >
                                {helperTitle}
                              </Text>
                            ) : null}
                            {touched[name] && errors[name] && (
                              <Text type={'error'} className={'error mt-2'}>
                                {errors[name]}
                              </Text>
                            )}
                          </div>
                        )}
                      </Fragment>
                    )
                  )}
                </div>
              )}
              {additionalBody ? additionalBody : ''}
              <div className="modal__form-footer">
                {submitButtonText ? (
                  <AntButton
                    htmlType="submit"
                    loading={onSubmitLoading}
                    className="modal__form-footer__submit-button"
                    disabled={disableSubmit}
                  >
                    {submitButtonText}
                  </AntButton>
                ) : null}
              </div>
              <div className="modal__form-footer">
                {cancelButtonText ? (
                  <AntButton
                    htmlType="cancel"
                    onClick={handleCancel}
                    loading={onSubmitLoading}
                    className="modal__form-footer__cancel-button"
                    disabled={disableSubmit}
                  >
                    {cancelButtonText}
                  </AntButton>
                ) : null}
              </div>
              {validationText ? validationText : ''}
              {hyperLink ? hyperLink : ''}
            </Form>
          )}
        </Formik>
      </div>
    </AntModal>
  );
};
